export default __webpack_public_path__ + "static/media/ic-download4.2b10d0ae.svg";